import { Injectable } from '@angular/core';
import { Meteor } from 'meteor/meteor';
import { Session } from 'meteor/session';

/**
 * Request a verification code.
 * @param selector The email or username of the user
 * @param [callback]
 */
const sendVerificationCode = function (selector: string, options: Object | Function, callback?: Function) {
  if (!callback && typeof options === 'function')
    callback = options;

  // Save the selector in a Session so even if the client reloads, the selector is stored
  Session.set('accounts-passwordless.selector', selector);
  return this.httpService.MeteorCall('accounts-passwordless.sendVerificationCode', selector, options, callback);
};

/**
 * Login with the verification code.
 * @param options code The verification code. selector The username or email (optional)
 * @param [callback]
 */
(Meteor as any).loginWithPasswordless = function (options, callback) {
  (Accounts as any).callLoginMethod({
    methodArguments: [{
      selector: Session.get('accounts-passwordless.selector') || options.selector,
      code: options.code
    }],
    userCallback: callback
  });
};

/**
 * Set username. The user must be logged
 * @param username The name of the user
 * @param [callback]
 */
(Meteor as any).setUsername = function (username, callback) {
  Meteor.call('accounts-passwordless.setUsername', username, callback);
};

@Injectable()
export class EmailLoginService {
  verify(email: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      sendVerificationCode(email, (e, result) => {
        if (e) {
          reject(e)
        }

        resolve(result);
      });
    });
  }

  login(email: string, code: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const options = {
        code,
        selector: 'email',
      };

      (Meteor as any).loginWithPasswordless(options, (e, result) => {
        if (e) {
          return reject(e)
        }
        resolve(result);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/email_login.ts